import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { OptionKey } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { api } from '@/api';
import { RAW_DATE_FORMAT } from '@/common/constants';
import { Pagination } from '@/common/types';
import { API_URL, IContributionRequestInfoAggregateDto } from '@/dtos';

import { ContributionListItemDto } from '../../contributions.types';

const QUERY_KEY = 'getContributionsQueryKey';


interface Props {
  startDate?: Date | null;
  endDate?: Date | null;
  accounts?: OptionKey[];
  sources?: OptionKey[];
  page?: number;
  perPage?: number;
}

export const useGetContributionsQuery = ({ startDate, endDate, accounts, sources, page, perPage }: Props) => {
  const { data, isLoading, refetch } = useQuery(
    [QUERY_KEY, page, perPage, accounts, sources, startDate, endDate],
    () =>
      api.get<Pagination<IContributionRequestInfoAggregateDto>>(API_URL.CONTRIBUTION_REQUESTS, {
        params: {
          ...(perPage ? { size: perPage } : {}),
          ...(page || page === 0 ? { page } : {}),
          ...(accounts?.length ? { plan_codes: accounts.join(',') } : {}),
          ...(sources ? { contribution_source: sources.join(',') } : {}),
          ...(startDate ? { submit_date_from: dayjs(startDate).format(RAW_DATE_FORMAT) } : {}),
          ...(endDate ? { submit_date_to: dayjs(endDate).format(RAW_DATE_FORMAT) } : {}),
        },
      }),
    {
      cacheTime: 0,
    }
  );

  const formattedData = useMemo(
    () => (data?.data.content || []) as unknown as ContributionListItemDto[],
    [data]
  );

  return {
    data: data?.data.content,
    formattedData,
    totalPages: data?.data.totalPages,
    totalElements: data?.data.totalElements,
    isLoading,
    refetch,
  };
};
